import { TServerHealthCareProvider } from '@/src/types/Common';

const HEALTH_CARE_PROVIDER_BASE_PATH_SE = 'klinik';

type TPartialServerHealthCareProvider = Omit<TServerHealthCareProvider, 'id' | 'clinicName'>;

// Hälsa i Kubik
const HALSA_I_KUBIK: TPartialServerHealthCareProvider = {
  slug: 'halsa-i-kubik',
  basePath: `${HEALTH_CARE_PROVIDER_BASE_PATH_SE}/halsa-i-kubik/`,
  lang: 'sv',
  market: 'SE',
  logo: '/images/halsa_i_kubik_logo.svg',
  loginImage: '/images/halsa_i_kubik_medarbetare_2024-wide.jpg',
  physicalRedirectUrl: 'https://halsaikubik.goactivebooking.com/',
  contactUrl: 'https://halsaikubik.se/kontakta-oss/',
  branding: {
    primary: {
      _5: '#FEF7F7',
      _10: '#FCEEEE',
      _15: '#FBE6E6',
      _20: '#F9DEDE',
      _30: '#F6CDCD',
      _40: '#F3BDBD',
      _50: '#F1ACAC',
      _60: '#EE9C9B',
      _70: '#EB8B8B',
      _80: '#E87B7A',
      _90: '#E56B6A',
      _100: '#E25A59',
      _110: '#CE3028',
    },
  },
};

// Active
const activeParams: Omit<TPartialServerHealthCareProvider, 'slug' | 'basePath' | 'physicalRedirectUrl'> = {
  lang: 'sv',
  market: 'SE',
  logo: '/images/active_logo.svg',
  loginImage: '/images/active-hero.jpg',
  branding: {
    primary: {
      _5: '#F3F7F5',
      _10: '#E7EFEA',
      _15: '#DBE7E0',
      _20: '#CFDFD6',
      _30: '#B6CFC1',
      _40: '#9EBFAC',
      _50: '#86AF97',
      _60: '#6EA083',
      _70: '#56906E',
      _80: '#3D8059',
      _90: '#257045',
      _100: '#0D6030',
      _110: '#13733c',
    },
  },
};

const ACTIVE_KINNA: TPartialServerHealthCareProvider = {
  slug: 'active-kinna',
  basePath: `${HEALTH_CARE_PROVIDER_BASE_PATH_SE}/active-kinna/`,
  physicalRedirectUrl: 'https://active.nu/boka-tid/kinna/',
  contactUrl: 'https://active.nu/kliniker/kinna/',
  ...activeParams,
};

const ACTIVE_LANDVETTER: TPartialServerHealthCareProvider = {
  slug: 'active-landvetter',
  basePath: `${HEALTH_CARE_PROVIDER_BASE_PATH_SE}/active-landvetter/`,
  physicalRedirectUrl: 'https://active.nu/boka-tid/landvetter/',
  contactUrl: 'https://active.nu/kliniker/landvetter/',
  ...activeParams,
};

const ACTIVE_GOTEBORG: TPartialServerHealthCareProvider = {
  slug: 'active-goteborg',
  basePath: `${HEALTH_CARE_PROVIDER_BASE_PATH_SE}/active-goteborg/`,
  physicalRedirectUrl: 'https://active.nu/boka-tid/goteborg/',
  contactUrl: 'https://active.nu/kliniker/goteborg/',
  ...activeParams,
};

const ACTIVE_KUNGALV: TPartialServerHealthCareProvider = {
  slug: 'active-kungalv',
  basePath: `${HEALTH_CARE_PROVIDER_BASE_PATH_SE}/active-kungalv/`,
  physicalRedirectUrl: 'https://active.nu/boka-tid/kungalv/',
  contactUrl: 'https://active.nu/kliniker/kungalv/',
  ...activeParams,
};

// Nacka Forum Rehab
const NACKA_FORUM_REHAB: TPartialServerHealthCareProvider = {
  slug: 'nacka-forum-rehab',
  basePath: `${HEALTH_CARE_PROVIDER_BASE_PATH_SE}/nacka-forum-rehab/`,
  lang: 'sv',
  market: 'SE',
  logo: '/images/nacka_forum_rehab_logo.png',
  hideJointAcademyLogo: true,
  physicalRedirectUrl: 'https://www.jointacademy.com/se/sv/kliniker/nacka-forum-rehab/',
};

// Rehab Aktivt Liv
const REHAB_AKTIVT_LIV: TPartialServerHealthCareProvider = {
  slug: 'rehab-aktivt-liv',
  basePath: `${HEALTH_CARE_PROVIDER_BASE_PATH_SE}/rehab-aktivt-liv/`,
  lang: 'sv',
  market: 'SE',
  logo: '/images/rehab_aktivt_liv_logo.png',
  loginImage: '/images/rehab-aktivt-liv-login.jpg',
  physicalRedirectUrl: 'https://www.rehabaktivtliv.se/',
  contactUrl: 'https://www.rehabaktivtliv.se/kontakt/',
  branding: {
    primary: {
      _5: '#F4F7FB',
      _10: '#E9F0F6',
      _15: '#DDE9F2',
      _20: '#D2E1ED',
      _30: '#BCD2E4',
      _40: '#A5C3DB',
      _50: '#8FB4D3',
      _60: '#79A5CA',
      _70: '#6296C1',
      _80: '#4C87B8',
      _90: '#3578AF',
      _100: '#1f69a6',
      _110: '#267bc0',
    },
  },
};

export const healthCareProviders: TPartialServerHealthCareProvider[] = [
  HALSA_I_KUBIK,
  ACTIVE_KINNA,
  ACTIVE_GOTEBORG,
  ACTIVE_KUNGALV,
  ACTIVE_LANDVETTER,
  NACKA_FORUM_REHAB,
  REHAB_AKTIVT_LIV,
];

export const getHealthCareProviderFromSlug = (slug?: string) => healthCareProviders.find(hcp => hcp.slug === slug);
